export default function Loading({text}) { 
  return (
    <section className="section is-small">
      <div className="box notification has-background-info-light has-text-info-dark">
        {text} <i className="fas fa-spinner fa-pulse"/>
      </div>
    </section>
  )
}